import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { getRegionColor } from '../../util/ColorUtil';
import {
  applyTruncationForScreen,
  countFacilityForMetro,
  getLowerCase,
  isItUndefined,
  marketoOptions,
  stripHtml,
  getAlgoliaIndex,
  handleGoTo,
  formatFilters,
  addQueryParamWithoutRedirecting,
  removeQueryParam,
  removeNbsp,
  noTruncationForAllScreen,
  pushSearchSuggestionClickEvent,
  pushFilterUsageDataLayer,
  pushDataLayerEvent,
} from '../../util/DataUtil';
import {
  excludeMetroDuplicateIDs,
  getAvaliableCloudFilters,
  getInfoBoxText,
  handleSeeMoreFacility,
  handleSeeMoreMetro,
  renderNoResult,
  getAvaliableCloudTetheredFilters,
} from '../../util/LocationsUtil';
import {
  renderNoResults,
  renderFilterBox,
  renderFilterBoxTethered,
  sortMetros,
} from '../../util/MapsUtil';
import { SearchBarPlacement } from '../../constants/SearchBarPlacement';
import { FilterName } from '../../constants/FilterName';
import {
  sendClickedObjectIDsAfterSearch,
  sendNoResultsEvent,
  getToken,
} from '../../util/AlgoliaInsights';

const Map = dynamic(() => import('../map/map'));
const MapFilter = dynamic(() => import('../map/search/MapFilter'));

const TemplateGlobalMap = (props) => {
  const [query, setQuery] = useState('');
  const [trigger, setTrigger] = useState(false);
  const [seeMoreMetro, setSeeMoreMetro] = useState(
    handleSeeMoreMetro(props.width)
  );
  const [seeMoreFacility, setSeeMoreFacility] = useState(
    handleSeeMoreFacility(props.width)
  );
  const [algoliaData, setalgoliaData] = useState([]);
  const [queryID, setQueryID] = useState(null);
  const [hitPerPages, setHitPerPages] = useState(32);
  const [filterProps, setFilterProps] = useState([]);
  const [tetheredFilters, setTetheredFilters] = useState([]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const router = useRouter();
  const [languageFilter, setLanguageFilter] = useState([]);
  const [metroData, setMetroData] = useState([]);
  const [currentZoom, setCurrentZoom] = useState(2);
  const [currentRegion, setCurrentRegion] = useState('');
  const [isToolTipActive, setIsToolTipActive] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [avaliableClouds, setAvaliableClouds] = useState(props?.dataCenters);
  const [firstLoad, setFirstLoad] = useState(false);
  const [loadCount, setLoadCount] = useState(0);

  useEffect(() => {
    if (filterProps?.length > 0) {
      getMetros(filterProps);
    } else {
      setMetroData(props?.locationsData?.metros);
      setNoResults(false);
    }

    return () => {
      setMetroData([]);
    };
  }, [filterProps]);

  useEffect(() => {
    if (!router?.query?.cloud) {
      return;
    }

    const cloudNames = Array.isArray(router.query.cloud)
      ? router.query.cloud
      : [router.query.cloud];
    const matchCategory = avaliableClouds.filter((item) =>
      cloudNames.some((cloudName) =>
        item.name.toLowerCase().includes(cloudName.toLowerCase())
      )
    );

    let filterProps = formatFilters(matchCategory);

    if (router?.query?.tethered === 'true') {
      setFirstLoad(true);

      filterProps = filterProps.reduce((result, obj) => {
        result.push(obj);
        if (!obj.name.includes('(T)') && !obj?.vid) {
          result.push({ name: obj.name + '(T)', tid: obj?.tid });
        }
        return result;
      }, []);
    }

    setFilterProps(filterProps);
  }, [router.query]);

  const triggerFilter = (filters) => {
    setFilterProps(filters);

    let searchFilters = [];
    for (let filter of filters) {
      searchFilters.push(filter?.field_source_translation);
    }
  };

  const getMetros = (filters) => {
    const { facilities, metros } = props?.locationsData;

    if (!facilities.length) {
      setNoResults(true);
      return;
    }

    const result = facilities.filter((item) =>
      filters.some((filter) =>
        isToggled
          ? item.field_available_clouds.some((e) =>
              e.name.toLowerCase().includes(filter.name.toLowerCase())
            ) ||
            item.field_available_tethered_t_acces.some((e) =>
              e.name.toLowerCase().includes(filter.name.toLowerCase())
            )
          : item.field_available_clouds.some((e) =>
              e.name.toLowerCase().includes(filter.name.toLowerCase())
            )
      )
    );

    setNoResults(result.length === 0);

    // const metrosOfFacility = result.map(facility =>
    //     metros.find(metro => facility?.metro === metro?.metro)
    // ).filter(Boolean);

    const metrosOfFacility = result
      .map((facility) => {
        const matchedMetro = metros.find(
          (metro) => facility?.metro === metro?.metro
        );
        return matchedMetro;
      })
      .filter(Boolean);

    setMetroData(
      metrosOfFacility.length ? [...new Set(metrosOfFacility)] : metros
    );

    if (metrosOfFacility.length === 0) {
      setMetroData(metros);
      setNoResults(true);
    }
  };

  const clearQuery = () => {
    setQuery('');
    props.setIsSearchActive(false);
    setIsFilterActive(true);
  };

  const clearAll = () => {
    setQuery('');
    setMetroData(props?.locationsData?.metros);
    setTrigger(!trigger);
    setIsFilterActive(false);
  };

  useEffect(() => {
    if (query) {
      getFromAlgolia(query);
    }
  }, [query, hitPerPages]);

  useEffect(() => {
    setSeeMoreFacility(handleSeeMoreFacility(props.width));
    setSeeMoreMetro(handleSeeMoreMetro(props.width));
  }, [query]);

  useEffect(() => {
    document
      .getElementsByClassName('input-container')[0]
      ?.classList.remove('focus');
  }, [trigger]);

  let facetFiltersArray = JSON.stringify([]);
  let tempLng = JSON.stringify('search_api_language:' + props.lang);

  const getFromAlgolia = async (query) => {
    const userToken = getToken();
    const tokenParam = userToken ? `&userToken=${encodeURIComponent(userToken)}` : '';
    const indexName = `alllocations${getAlgoliaIndex()}`;
    const url =
      'https://O2VJB2KMPB-dsn.algolia.net/1/indexes/' +
      indexName +
      '?query=' +
      encodeURIComponent(query) +
      '&facetFilters=[' +
      facetFiltersArray +
      ',' +
      tempLng +
      ',["status:true"]]' +
      `&hitsPerPage=${1000}&clickAnalytics=true${tokenParam}`;
    await fetch(url, marketoOptions)
      .then((response) => response.json())
      .then((algolia) => {
        algolia.hitPerPages = 1000;
        setalgoliaData(algolia.hits);
        setQueryID(algolia.queryID || null);
        if (algolia.hits.length === 0) {
          sendNoResultsEvent(algolia.queryID, indexName);
        }
      });
  };

  const renderSearchResults = (query) => {
    let filteredMetros;
    let filteredFacilities;
    let metroResult = [];
    let metrosHtml = [];
    let facilitiesHtml = [];
    let numberOfFacilities = 0;

    if (!query || query.length < 2) {
      return;
    }

    if (algoliaData?.length == 0) {
      return renderNoResult(props.global, clearAll);
    }

    filteredMetros = algoliaData.filter(
      (x) => x.type === 'metro' && x?.objectID?.endsWith(props?.lang)
    );
    filteredFacilities = algoliaData.filter(
      (e) => e.type === 'location' && e?.objectID?.endsWith(props?.lang)
    );

    filteredMetros?.map((metro) => {
      filteredFacilities.map((facility) => {
        if (facility?.facility_metro == metro?.metro_name) {
          metroResult.push(metro);
        }
      });
    });

    if (filteredFacilities?.length > 0) {
      props?.locationsData?.metros.map((metro) => {
        filteredFacilities.map((facility) => {
          if (facility?.facility_metro == metro?.metro) {
            metroResult.push(metro);
          }
        });
      });
    }

    filteredMetros = [...new Set(metroResult), ...new Set(filteredMetros)];
    filteredMetros = [...new Set(filteredMetros)];
    filteredMetros = excludeMetroDuplicateIDs(filteredMetros);

    if (algoliaData?.length == 0) {
      return renderNoResult(props.global, clearAll);
    }

    let orderedMetros = sortMetros(filteredMetros, query);

    // filteredMetros.map((item, key) => {
    orderedMetros.map((item, key) => {
      metrosHtml.push(
        <div
          onClick={() => {
            pushSearchSuggestionClickEvent(
              Array.isArray(query)
                ? (query[0]?.toLowerCase() ?? '')
                : (query?.toLowerCase() ?? ''),
              SearchBarPlacement.DATA_CENTERS,
              item?.metro_name ? item?.metro_name : item?.metro,
              key + 1
            );
            sendClickedObjectIDsAfterSearch(queryID, item.objectID, `alllocations${getAlgoliaIndex()}`, key + 1);
            item?.url
              ? handleGoTo(item?.url, router, props?.lang)
              : handleGoTo(item['url-alias'], router, props?.lang);
          }}
          className="div-metro-map-link metro"
          key={`metro-${item.objectID || item.metro_name || item.metro || key}`}
        >
          <img alt="search" src={item?.metro_image} />
          <div className="right">
            <span className="title">
              {item?.metro_name ? item?.metro_name : item?.metro}
            </span>
            <span className="sub-title">
              {noTruncationForAllScreen(
                typeof item?.field_intro === 'string'
                  ? item?.field_intro
                  : isItUndefined(item?.field_intro),
                90,
                67,
                67,
                67
              )}
            </span>
          </div>
        </div>
      );
    });

    filteredFacilities.map((item, key) => {
      numberOfFacilities++;
      facilitiesHtml.push(
        <div
          onClick={() => {
            pushSearchSuggestionClickEvent(
              Array.isArray(query)
                ? (query[0]?.toLowerCase() ?? '')
                : (query?.toLowerCase() ?? ''),
              SearchBarPlacement.DATA_CENTERS,
              item?.facility_metro + ' ' + item?.field_site_code_location,
              key + 1
            );
            sendClickedObjectIDsAfterSearch(queryID, item.objectID, `alllocations${getAlgoliaIndex()}`, numberOfFacilities);
            handleGoTo(item?.url, router, props?.lang);
          }}
          key={`facility-index-${numberOfFacilities}`}
          className={`div-metro-map-link facility ${getRegionColor(item)}`}
        >
          <img alt="pin" src="/images/map-pin.svg" />

          <div className="right">
            <span className="title">
              {item?.facility_metro} {item?.field_site_code_location}
            </span>
            <a target="_blank" className="a-regional-map-link address">
              {removeNbsp(stripHtml(item?.facility_address))}
            </a>
          </div>
        </div>
      );
    });

    return getHtmlResult(
      metrosHtml,
      facilitiesHtml,
      metrosHtml.length,
      numberOfFacilities
    );
  };

  const getHtmlResult = (
    metros,
    facilities,
    numberOfMetros,
    numberOfFacilities
  ) => {
    // facilities = facilities.slice(0, seeMoreFacility);
    // metros = metros.slice(0, seeMoreMetro);
    return (
      <>
        <div className="metro-results">
          <span className="regional-result-header">
            {props?.global?.field_metro_label?.[0]?.value || 'Metro'} (
            {numberOfMetros})
          </span>
          {metros}
          {metros.length !== numberOfMetros && (
            <div
              className={'see-more'}
              onClick={() => {
                setSeeMoreMetro(
                  seeMoreMetro + handleSeeMoreMetro(props?.width)
                );
                setHitPerPages(hitPerPages + 16);
              }}
            >
              See More
            </div>
          )}
        </div>
        <div className="facility-results">
          <span className="regional-result-header">
            {props?.global?.field_facility_label?.[0]?.value || 'Facility'} (
            {numberOfFacilities})
          </span>
          <div className="facilities">{facilities}</div>
          {facilities.length !== numberOfFacilities && (
            <div
              className={'see-more'}
              onClick={() => {
                setSeeMoreFacility(
                  seeMoreFacility + handleSeeMoreFacility(props?.width)
                );
                setHitPerPages(hitPerPages + 16);
              }}
            >
              See More
            </div>
          )}
        </div>
      </>
    );
  };

  const regionData = [
    {
      name: 'APAC',
      id: 1,
      lng: '112.14843750000001',
      lat: '37.30027528134433',
      region: 'apac',
    },
    {
      name: 'EMEA',
      id: 2,
      lng: '10.371093750000002',
      lat: '49.95121990866204',
      region: 'emea',
    },
    {
      name: 'Americas',
      id: 3,
      lng: '-80.03125000000001',
      lat: '18.59704151614417',
      region: 'americas',
      label: isItUndefined(props?.children?.field_americas_label),
    },
  ];

  const subRegionData = [
    {
      name: 'North America',
      id: 1,
      lat: '35.72710465474199',
      lng: '-72.765750119032',
      region: 'americas',
      regionKey: 'northAmerica',
      label: isItUndefined(props?.children?.field_north_america_label),
    },
    {
      name: 'South America',
      id: 2,
      lat: '0.470810911992732',
      lng: '-72.765750119032',
      region: 'americas',
      regionKey: 'southAmerica',
      label: isItUndefined(props?.children?.field_south_america_label),
    },
    {
      name: 'Europe',
      id: 3,
      lat: '50.90434747644453',
      lng: '13.114154724145223',
      region: 'emea',
      regionKey: 'europe',
      label: isItUndefined(props?.children?.field_europe_label),
    },
    {
      name: 'Africa',
      id: 4,
      lat: '21.108711157473934',
      lng: '13.114154724145223',
      region: 'emea',
      regionKey: 'africa',
      label: isItUndefined(props?.children?.field_africa_label),
    },
    {
      name: 'Asia',
      id: 5,
      lat: '25.50896779643949',
      lng: '100.86191043395011',
      region: 'apac',
      regionKey: 'asia',
      label: isItUndefined(props?.children?.field_asia_label),
    },
    {
      name: 'Australia',
      id: 6,
      lat: '-10.5962531319614595',
      lng: '101.38925416286246',
      region: 'apac',
      regionKey: 'australia',
      label: isItUndefined(props?.children?.field_australia_label),
    },
  ];

  const countMetrosForRegion = (metros) => {
    let resultAmericas = [];
    let resultEmea = [];
    let resultApac = [];

    metros.map((e) => {
      if (getLowerCase(e.region) === 'americas') {
        resultAmericas.push(e);
      } else if (getLowerCase(e.region) === 'apac') {
        resultApac.push(e);
      } else if (getLowerCase(e.region) === 'emea') {
        resultEmea.push(e);
      }
      return;
    });

    return {
      americas: resultAmericas?.length,
      apac: resultApac?.length,
      emea: resultEmea?.length,
    };
  };

  const renderRegionMarkers = (regions) => {
    if (!regions.length) return;

    let result = [];

    regions.map((item) => {
      if (!item?.lng || !item?.lat) return;
      result.push({
        type: 'region',
        name: item?.name,
        latitude: Number(item?.lat),
        longitude: Number(item?.lng),
        regionColor: getLowerCase(item?.region),
        numberOfMetros:
          filterProps?.length > 0 ? countMetrosForRegion(metroData) : undefined,
        label: item?.label,
      });
    });

    return result;
  };

  const renderSubRegionMarkers = (subregions) => {
    if (subregions?.length == 0) return;

    let result = [];

    subregions.map((item) => {
      if (!item?.lng || !item?.lat) return;
      result.push({
        type: 'sub-region',
        name: item?.name,
        latitude: Number(item?.lat),
        longitude: Number(item?.lng),
        regionColor: getLowerCase(item?.region),
        numberOfMetros:
          filterProps?.length > 0
            ? countMetrosForContinent(metroData)
            : undefined,
        regionKey: item?.regionKey,
        label: item?.label,
      });
    });

    return result;
  };

  const countMetrosForContinent = (metros) => {
    let resultNorthAmerica = [];
    let resultSouthAmerica = [];
    let resultAfrica = [];
    let resultEurope = [];
    let resultAsia = [];
    let resultAustralia = [];

    metros.map((e) => {
      switch (e?.field_metro_name[0]?.continent) {
        case 'North America':
          resultNorthAmerica.push(e);
          break;
        case 'South America':
          resultSouthAmerica.push(e);
          break;
        case 'Africa':
          resultAfrica.push(e);
          break;
        case 'Europe':
          resultEurope.push(e);
          break;
        case 'Asia':
          resultAsia.push(e);
          break;
        case 'Australia':
          resultAustralia.push(e);
          break;
        default:
          break;
      }
    });

    return {
      northAmerica: resultNorthAmerica?.length,
      southAmerica: resultSouthAmerica?.length,
      africa: resultAfrica?.length,
      europe: resultEurope?.length,
      asia: resultAsia?.length,
      australia: resultAustralia?.length,
    };
  };

  const renderMetroMarkers = (metros) => {
    if (!metros.length) return;
    let result = [];

    metros.map((item) => {
      if (!item?.field_latitude[0]?.value || !item?.field_longitude[0]?.value)
        return;
      let numberOfFacilitiesInMetro = countFacilityForMetro(
        item?.metro,
        props?.locationsData?.facilities
      );

      let avaliableFilters = getAvaliableCloudFilters(
        item.metro,
        props.locationsData.facilities
      );
      let metroNameOriginalTranslation = item?.field_metro_name?.[0]?.original_tranlsation;
      const flattenedList = [
        ...new Set(
          avaliableFilters?.flatMap((list) =>
            list.map((item) => JSON.stringify(item))
          )
        ),
      ].map((item) => JSON.parse(item));

      let availableFiltersTethered = getAvaliableCloudTetheredFilters(
        item?.metro,
        props?.locationsData?.facilities
      );
      const flattenedListTethered = [
        ...new Set(
          availableFiltersTethered.flatMap((list) =>
            list.map((item) => JSON.stringify(item))
          )
        ),
      ].map((item) => JSON.parse(item));

      result.push({
        type: 'metro',
        latitude: parseFloat(item?.field_latitude[0]?.value),
        longitude: parseFloat(item?.field_longitude[0]?.value),
        regionColor: getLowerCase(item?.region),
        name: item?.field_metro_name[0]?.name,
        numberOfFacilities: numberOfFacilitiesInMetro,
        shortCode: isItUndefined(item?.field_metro_short_code),
        link: item['url-alias'],
        intro: isItUndefined(item?.field_intro),
        infoText: getInfoBoxText(
          isItUndefined(props?.children?.field_info_box_text),
          numberOfFacilitiesInMetro
        ),
        avaliableFilters: flattenedList?.length > 0 ? flattenedList : [],
        availableFiltersTethered:
          flattenedListTethered?.length > 0 ? flattenedListTethered : [],
          metroLocation: metroNameOriginalTranslation,
      });
    });

    return result;
  };

  const renderClusterMetroMarkers = (metros) => {
    if (!metros.length) return;

    let result = [];

    metros.map((item) => {
      if (!item?.field_latitude[0]?.value || !item?.field_longitude[0]?.value)
        return;
      result.push({
        type: 'Feature',
        properties: {
          cluster: false,
          id: Math.random(),
          regionColor: getLowerCase(item?.region),
        },
        geometry: {
          type: 'Point',
          coordinates: [
            Number(item?.field_longitude[0]?.value),
            Number(item?.field_latitude[0]?.value),
          ],
        },
        text: '',
      });
    });
    return result;
  };

  const handleSearch = (search) => {
    setQuery(search.length !== 0 ? search : '');
  };

  const getGlobalMapData = () => {
    if (
      !renderRegionMarkers(regionData).length ||
      !renderMetroMarkers(props?.locationsData?.metros)
    ) {
      renderNoResults();
    }

    return [
      ...renderRegionMarkers(regionData),
      ...renderMetroMarkers(
        metroData?.length == 0 ? props?.locationsData?.metros : metroData
      ),
      ...renderSubRegionMarkers(subRegionData),
    ];
  };

  useEffect(() => {
    props.setIsSearchActive(typeof renderSearchResults(query) === 'object');
  }, [renderSearchResults(query)]);

  const renderMapHelpers = () => {
    return (
      <>
        {currentRegion !== 'americas' &&
          currentRegion !== 'south-america' &&
          currentRegion !== 'north-america' && (
            <span
              style={{ backgroundColor: '#1F00FF' }}
              className="americas"
              onClick={() => {
                pushDataLayerEvent('metro_map_click', {
                  region_location: 'americas',
                });
                setCurrentRegion('americas');
              }}
            >
              <div>{isItUndefined(props?.children?.field_americas_label)}</div>{' '}
              <img
                width={'auto'}
                height={'auto'}
                src={'/images/arrow-right-white.svg'}
                alt={'scroll-arrow'}
              />
            </span>
          )}
        {currentRegion !== 'emea' &&
          currentRegion !== 'europe' &&
          currentRegion !== 'africa' && (
            <span
              style={{ backgroundColor: '#7700EC' }}
              className="emea"
              onClick={() => {
                pushDataLayerEvent('metro_map_click', {
                  region_location: 'emea',
                });
                setCurrentRegion('emea');
              }}
            >
              <div>EMEA</div>{' '}
              <img
                width={'auto'}
                height={'auto'}
                src={'/images/arrow-right-white.svg'}
                alt={'scroll-arrow'}
              />
            </span>
          )}
        {currentRegion !== 'apac' &&
          currentRegion !== 'australia' &&
          currentRegion !== 'asia' && (
            <span
              style={{ backgroundColor: '#01454f' }}
              className="emea"
              onClick={() => {
                pushDataLayerEvent('metro_map_click', {
                  region_location: 'apac',
                });
                setCurrentRegion('apac');
              }}
            >
              <div>APAC</div>{' '}
              <img
                width={'auto'}
                height={'auto'}
                src={'/images/arrow-right-white.svg'}
                alt={'scroll-arrow'}
              />
            </span>
          )}
        {currentRegion !== 'north-america' &&
          currentRegion == 'south-america' &&
          currentZoom == 4 && (
            <span
              style={{ backgroundColor: '#1F00FF' }}
              className="emea new-padding fixed-font"
              onClick={() => {
                pushDataLayerEvent('metro_map_click', {
                  continent_location: 'north america',
                });
                setCurrentRegion('north-america');
              }}
            >
              {isItUndefined(props?.children?.field_north_america_label)}
              <img
                width={'auto'}
                height={'auto'}
                src={'/images/arrow-right-white.svg'}
                alt={'scroll-arrow'}
              />
            </span>
          )}
        {currentRegion == 'north-america' && currentZoom == 4 && (
          <span
            style={{ backgroundColor: '#1F00FF' }}
            className="emea new-padding fixed-font"
            onClick={() => {
              pushDataLayerEvent('metro_map_click', {
                continent_location: 'south america',
              });
              setCurrentRegion('south-america');
            }}
          >
            {isItUndefined(props?.children?.field_south_america_label)}{' '}
            <img
              width={'auto'}
              height={'auto'}
              src={'/images/arrow-right-white.svg'}
              alt={'scroll-arrow'}
            />
          </span>
        )}
        {currentRegion === 'africa' && currentZoom == 4 && (
          <span
            style={{ backgroundColor: '#7700EC' }}
            className="emea"
            onClick={() => {
              pushDataLayerEvent('metro_map_click', {
                continent_location: 'europe',
              });
              setCurrentRegion('europe');
            }}
          >
            {isItUndefined(props?.children?.field_europe_label)}{' '}
            <img
              width={'auto'}
              height={'auto'}
              src={'/images/arrow-right-white.svg'}
              alt={'scroll-arrow'}
            />
          </span>
        )}
        {currentRegion === 'europe' && currentZoom == 4 && (
          <span
            style={{ backgroundColor: '#7700EC' }}
            className="emea"
            onClick={() => {
              pushDataLayerEvent('metro_map_click', {
                continent_location: 'africa',
              });
              setCurrentRegion('africa');
            }}
          >
            {isItUndefined(props?.children?.field_africa_label)}{' '}
            <img
              width={'auto'}
              height={'auto'}
              src={'/images/arrow-right-white.svg'}
              alt={'scroll-arrow'}
            />
          </span>
        )}
        {currentRegion === 'australia' && currentZoom == 4 && (
          <span
            style={{ backgroundColor: '#01454f' }}
            className="emea"
            onClick={() => {
              pushDataLayerEvent('metro_map_click', {
                continent_location: 'asia',
              });
              setCurrentRegion('asia');
            }}
          >
            {isItUndefined(props?.children?.field_asia_label)}{' '}
            <img
              width={'auto'}
              height={'auto'}
              src={'/images/arrow-right-white.svg'}
              alt={'scroll-arrow'}
            />
          </span>
        )}
        {currentRegion === 'asia' && currentZoom == 4 && (
          <span
            style={{ backgroundColor: '#01454f' }}
            className="emea"
            onClick={() => {
              pushDataLayerEvent('metro_map_click', {
                continent_location: 'australia',
              });
              setCurrentRegion('australia');
            }}
          >
            {isItUndefined(props?.children?.field_australia_label)}{' '}
            <img
              width={'auto'}
              height={'auto'}
              src={'/images/arrow-right-white.svg'}
              alt={'scroll-arrow'}
            />
          </span>
        )}
      </>
    );
  };

  // const renderMapHelpers = () => {
  //     return(
  //         <>
  //             <span style={{backgroundColor: '#01454f'}} className='emea' onClick={() => { setCurrentRegion(regions.name) }}>
  //                 {isItUndefined(props?.children?.field_australia_label)} <img width={'auto'} height={'auto'} src={'/images/arrow-right-white.svg'} alt={'scroll-arrow'}/>
  //             </span>
  //         </>
  //     )
  // }

  const handleToggleChange = () => {
    setIsToggled(!isToggled);

    let url = '';

    if (typeof window !== 'undefined') {
      url = window.location.pathname;
    }

    if (isToggled) {
      // pushFilterUsageDataLayer(
      //   FilterName.GLOBAL_MAP,
      //   'excludes tethered access'
      // );
      removeQueryParam(router, 'true'); // remove tethered from url
    } else {
      pushFilterUsageDataLayer(
        FilterName.GLOBAL_MAP,
        'includes tethered access'
      );
      addQueryParamWithoutRedirecting(router, url, 'true', 'tethered');
    }
  };

  const handleToggleChangeOnFirstLoad = () => {
    if (loadCount < 1) {
      setIsToggled(true);
    }

    setLoadCount(1);
  };

  return (
    <div className="template-global-map">
      <MapFilter
        lang={props?.lang}
        router={router}
        clearQuery={clearQuery}
        isSearchActive={props?.isSearchActive}
        isFilterActive={isFilterActive}
        setIsSearchActive={props?.setIsSearchActive}
        setIsFilterActive={setIsFilterActive}
        data={[
          {
            id: 1,
            name: isItUndefined(props?.children?.field_filter_group_label),
            description: '',
            children: formatFilters(avaliableClouds),
          },
        ]}
        setQuery={setQuery}
        clearAll={clearAll}
        searchQuery={query}
        onSearchChange={handleSearch}
        search={props?.children?.field_searct[0]?.value}
        title={isItUndefined(props?.children?.field_filter_text)}
        filterProps={filterProps}
        triggerFilter={triggerFilter}
        languageFilter={languageFilter}
        setLanguageFilter={setLanguageFilter}
        screenWidth={props?.width}
        component={'global'}
        cancelText={isItUndefined(props?.global?.field_cancel_text_translation)}
        applyFilterText={isItUndefined(props?.global?.field_apply_filters_text)}
        clearAllText={isItUndefined(props?.global?.field_clear_all_text)}
        selectedText={isItUndefined(props?.global?.field_selected_text)}
        seeMoreText={isItUndefined(props?.global?.field_see_more_text)}
        seeLessText={isItUndefined(props?.global?.field_see_less)}
        toggleText={isItUndefined(props?.children?.field_toggle_button_text)}
        onToggleChange={handleToggleChange}
        isToggled={isToggled}
        tooltipText={isItUndefined(props?.children?.field_tooltip_text)}
        setTetheredFilters={setTetheredFilters}
        pageType={'global-map'}
        firstLoad={firstLoad}
        handleToggleChangeOnFirstLoad={handleToggleChangeOnFirstLoad}
        dataLayerFilterName={FilterName.GLOBAL_MAP}
      />
      <div className="inner-container">
        {typeof renderSearchResults(query, props?.locationsData) ==
          'object' && (
          <div className="search-result-container">
            {renderSearchResults(query, props?.locationsData)}
          </div>
        )}
      </div>
      <div
        className={`global-map ${isToolTipActive ? 'active' : ''}${props?.lang !== 'en' ? 'font-reduce' : ''}`}
      >
        <Map
          setIsToolTipActive={setIsToolTipActive}
          lenghtOfFilters={filterProps?.length}
          width={props?.width}
          filterText={isItUndefined(props?.children?.field_filter_group_label)}
          filterTextTethered={isItUndefined(
            props?.children?.field_filter_group_2_label
          )}
          currentRegion={currentRegion}
          setCurrentRegion={setCurrentRegion}
          currentZoom={currentZoom}
          setCurrentZoom={setCurrentZoom}
          maxZoom={4}
          globalMap={true}
          blockTypeClass={'global-map'}
          zoom={2}
          latitude={-2.0}
          longitude={12.17403}
          metroMarkers={renderClusterMetroMarkers(props?.locationsData?.metros)}
          renderMarkers={getGlobalMapData()}
          isToggled={isToggled}
        />
        {currentZoom >= 3 && (
          <div className="map-action-helper">{renderMapHelpers()}</div>
        )}
        {noResults && filterProps.length > 0 ? (
          <div className={'filter-info-box no-results'}>
            {renderNoResults(props?.children?.field_no_results_text)}
          </div>
        ) : (
          tetheredFilters?.length > 0 && (
            <div
              className={
                isToggled ? 'filter-info-box tethered' : 'filter-info-box'
              }
            >
              {renderFilterBox(
                tetheredFilters,
                props?.children?.field_filter_display_text
              )}
              {isToggled &&
                renderFilterBoxTethered(
                  tetheredFilters,
                  props?.children?.field_filter_display_text_2
                )}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default TemplateGlobalMap;
